import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceBase } from '../../core/service/service.base';

import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../core/service/auth.service';
import { LogService } from '../../core/service/log.service';
import { CustomErrorHandler } from '../../core/service/CustomErrorHandler';
import { AssessmentRegistration } from '../model/AssessmentRegistration';
import { FinalDeclaration } from '../model/FinalDeclaration';
import { VRApplication } from '../model/VRApplication';

@Injectable()
export class PreregApplicationService extends ServiceBase {

    constructor(
        http: HttpClient,
        auth: AuthService,
        log: LogService,
        errorHandler: CustomErrorHandler
    ) {
        super(http, auth, log, errorHandler);
    }

    public getRegApplication(preregNumber: string): Observable<any> {
        return this.get(`/v1.0/registrationdocument?PreEntryNumber=${preregNumber}`);
    }

    public getPreregApplication(preregNumber: string): Observable<any> {
        return this.get(`/v1.0/preregdocument?PreEntryNumber=${preregNumber}`);
    }

    public getTechnicianApplication(preentryNumber: string): Observable<any> {
        return this.get(`v1.0/techniciandocument?PreEntryNumber=${preentryNumber}`);
    }

    public getAssessmentApplication(preentryNumber: string): Observable<any> {
        // return this.get(`v1.0/admin/progressreport/thirtynineweek?PreEntryNumber=4300712`);
        return this.get(`v1.0/admin/progressreport/thirtynineweek?PreEntryNumber=${preentryNumber}`);
    }
    public getExamApplication(preentryNumber: string): Observable<AssessmentRegistration> {
        return this.get(`v1.0/admin/assessmentregistration?PreEntryNumber=${preentryNumber}`);

    }

    public getFinalDeclarationApplication(preentryNumber: string): Observable<FinalDeclaration> {
        return this.get(`v1.0/admin/finaldeclaration?preentrynumber=${preentryNumber}`);

    }

    public getPrescriberApplication(registrationNumber: string): Observable<any> {
      return this.get(`v1.0/admin/independentprescriber?registrationNumber=${registrationNumber}`);

    }

    public getVRApplication(registrationNumber: string): Observable<VRApplication>{
        return this.get(`v1.0/admin/voluntaryremoval?RegistrationNumber=${registrationNumber}`);
    }

    public deleteVRApplication(registrationNumber: string): Observable<any>{
        return this.post(`v1.0/admin/voluntaryremoval`,{RegistrationNumber: registrationNumber});
    }

    public deleteCCPSApplication(registrationNumber: string): Observable<any>{
        return this.post(`v1.0/admin/professionalstandingapp`,{RegistrationNumber: registrationNumber});
    }

    public getRTRApplication(registrationNumber: string): Observable<any>{
        return this.get(`v1.0/admin/returntoregister?registrationnumber=${registrationNumber}`);
    }

    public getCCPSApplication(registrationNumber: string): Observable<any>{
        return this.get(`v1.0/admin/professionalstandingapp?registrationnumber=${registrationNumber}`);
    }

    rejectSubmission(formId: string | number, submissionId: string | number): Observable<any> {
        return this.post('v1.0/admin/ReturnToRegister/rejectreval',{formId, submissionId})
    }

    download(url: string) {
        return this.getFile(url);
    }
}
